import { render, staticRenderFns } from "./status-form-estate.vue?vue&type=template&id=9962ad2a&scoped=true&"
import script from "./status-form-estate.vue?vue&type=script&lang=js&"
export * from "./status-form-estate.vue?vue&type=script&lang=js&"
import style0 from "./status-form-estate.vue?vue&type=style&index=0&id=9962ad2a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9962ad2a",
  null
  
)

export default component.exports